(function uiSearchBarModuleDefinition() {
    'use strict';

    angular.module('UiSearchBar', [])
        .directive('uiSearchBar', ['$state', 'auth', 'authExtend', 'errorsExtend', 'storageService', '$rootScope', 'documentTypeService', 'containerTypeService', '$uibModal', 'documentService', 'userService', '$timeout',
            function ($state, auth, authExtend, errors, storageService, $rootScope, documentTypeService, containerTypeService, $modal, documentService, userService, $timeout) {
                return {
                    restrict: 'E',
                    templateUrl: '/app/directives/ui-search-bar/ui-search-bar.html',
                    scope: {
                        results: '='
                    },
                    controller: [
                        '$scope', '$element', function ($scope, $element) {
                            $scope.isOpen = false;

                            $scope.idTypeName = "DocumentIdFilter";
                            $scope.focused = false;

                            $scope.find = {
                                name: '',
                                documentId: 0,
                                createdDateFrom: '',
                                createdDateTo: '',
                                createdBy: '',
                                class: undefined,
                                documentIdFilter: '',
                                documentCreationDateFilterFrom: '',
                                documentCreationDateFilterTo: '',
                                selectedUser: {},
                                itemsPerPage: 15,
                                page: 1,
                                documentFullText: false
                        };

                            $scope.optionsClasses = [];
                            $scope.dateTimePickerFromOptions = {};
                            $scope.dateTimePickerToOptions = {};

                            $scope.metadata = {
                                title: '',
                                version: '',
                                client: '',
                                dateFrom: undefined,
                                dateTo: undefined
                            };

                            $scope.init = function () {
                                $scope.find = storageService.getSearchBarFilter();
                                $scope.documentRead = authExtend.isInRole('DOCUMENTCONTAINER READ');
                                $scope.documentContainerRead = authExtend.isInRole('DOCUMENT READ');
                                $scope.isImpersonated = authExtend.getOrganizationId() !== '';
                                $scope.getClassOptions();
                            };

                            auth.onIdentityChanged(function identityChangedFn() {
                                $scope.documentRead = authExtend.isInRole('DOCUMENTCONTAINER READ');
                                $scope.documentContainerRead = authExtend.isInRole('DOCUMENT READ');
                                $scope.isImpersonated = authExtend.getOrganizationId() !== '';
                                $scope.find.name = '';
                                $scope.find = storageService.getSearchBarFilter();
                                $scope.getClassOptions();
                            });

                            $scope.searchUser = function () {
                                if (!$scope.find.selectedUser || !$scope.find.selectedUser.nickName || $scope.find.selectedUser.nickName.length < 1) {
                                    $scope.openModalUser();
                                }
                                else {
                                    $scope.selectUser();
                                }
                            };

                            $scope.openModalUser = function () {
                                $scope.find.selectedUser = {};
                                var modalInstance = $modal.open({
                                    templateUrl: '/app/directives/custom-control-user/custom-control-user-modal.html',
                                    controller: 'UserSearchModalController',
                                    size: 'lg',
                                    resolve: {
                                        ouId: function () {
                                            return $scope.ouId;
                                        },
                                        info: function () {

                                        }
                                    }
                                });

                                modalInstance.result.then(function (result) {

                                    // TODO: Fix this!
                                    $timeout(function () {
                                        // anything you want can go here and will safely be run on the next digest.
                                        $('.advanced-search-trigger').click();
                                    });


                                    if (result) {
                                        $scope.find.selectedUser = result;
                                    }
                                    else {
                                        $scope.find.selectedUser = {};
                                    }
                                });
                            };

                            $scope.setFocus = function (value) {
                                $scope.find.focused = value;
                            }

                            $scope.selectUser = function () {
                                userService.get($scope.find.selectedUser.nickName, null, null, null, null, null).then(function (result) {
                                    if (result.value[0]) {
                                        $scope.find.selectedUser = result.value[0];
                                    }
                                    else {
                                        $scope.openModalUser();
                                    }

                                }, function () {
                                    $scope.openModalUser();
                                });
                            };

                            $scope.goToHome = function () {
                                var elemento = document.getElementById("searchBar");
                                elemento.blur();
                                storageService.setSearchBarFilter($scope.find);

                                if ($state.current.controller === 'InicioController') {
                                    $rootScope.$broadcast('Search-Bar-Menu', $scope.find);
                                }
                                else {
                                    $state.go('inicio');
                                }
                            };

                            $scope.selectClass = function (docClass) {
                                $scope.find.classType = docClass.group;

                                if (docClass.group === 'Documental') {
                                    documentTypeService.getById(docClass.id, 'Detail', 'DOCUMENT READ').then(function (result) {
                                        $scope.LoadClassMetadata(result);
                                        $scope.idTypeName = "DocumentIdFilter";
                                    }, function (error) {
                                        errors.showError(error);
                                    });
                                }
                                else if (docClass.group === 'Carpeta') {
                                    containerTypeService.getById(docClass.id, 'Detail', 'DOCUMENT READ').then(function (result) {
                                        $scope.LoadClassMetadata(result);
                                        $scope.idTypeName = "ContainerIdFilter";
                                    }, function (error) {
                                        errors.showError(error);
                                    });
                                }
                            };

                            $scope.LoadClassMetadata = function (docClass) {
                                var documentClass = {
                                    systemName: docClass.systemName,
                                    name: docClass.name,
                                    typeId: docClass.id,
                                    metadatas: []
                                };

                                docClass.metadata.forEach(function (metadata) {
                                    if (metadata.isSearchCriteria) {
                                        documentClass.metadatas.push(
                                            {
                                                idObject: documentClass.containerTypeId + '' + metadata.metadataId,
                                                metadataId: metadata.metadataId,
                                                metadataValueFrom: undefined,
                                                metadataValueTo: undefined,
                                                metadataSearchTypeFrom: undefined, // cada control pisa el valor
                                                metadataSearchTypeTo: undefined, // cada control pisa el valor
                                                metadataType: metadata.metadataType,
                                                metadataSystemName: metadata.metadataSystemName,
                                                metadataLabel: metadata.metadataLabel,
                                                metadataOptions: metadata.optionValues,
                                                metadataIsMultivalue: metadata.isMultivalue,
                                                maskOptions: metadata.maskOptions,
                                                mask: metadata.metadataMask,
                                                maskPlaceHolder: metadata.metadataMaskPlaceHolder
                                            });
                                    }
                                });

                                $scope.find.class = documentClass;
                            };

                            $scope.toggleSearch = function () {
                                $scope.advOptionsIsOpen = !$scope.advOptionsIsOpen;
                            };

                            $scope.getClassOptions = function () {
                                $scope.getDocumentTypeOptions();
                                $scope.getContainerTypeOptions();
                            };

                            $scope.getDocumentTypeOptions = function () {
                                $scope.optionsClasses = [];

                                documentTypeService.getFunctionsTypes(['DOCUMENT READ', 'DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE']).then(function (result) {
                                    $scope.optionsDocumentTypes = result.sort(function (a, b) {
                                        return a.name.localeCompare(b.name);
                                    });

                                    $scope.optionsDocumentTypes.forEach(function (option) {
                                        option.group = 'Documental';
                                        $scope.optionsClasses.push(option);
                                    });

                                }, function (error) {
                                    errors.showError(error);
                                });
                            };

                            $scope.getContainerTypeOptions = function () {
                                $scope.optionsClasses = [];

                                containerTypeService.getFunctionsTypes(['DOCUMENTCONTAINER READ']).then(function (result) {
                                    $scope.optionsContainerTypes = result.sort(function (a, b) {
                                        return a.name.localeCompare(b.name);
                                    });

                                    $scope.optionsContainerTypes.forEach(function (option) {
                                        option.group = 'Carpeta';
                                        $scope.optionsClasses.push(option);
                                    });

                                }, function (error) {
                                    errors.showError(error);
                                });
                            };


                            $scope.status = {
                                isopen: false
                            };



                            $scope.search = function () {
                                $scope.status.isopen = !$scope.status.isopen;

                                var filters = {
                                    Complete: true,
                                    DocumentTypes: [],
                                    ContainerTypes: [],
                                    organizationUnitIds: []
                                };

                                $scope.find.page = 1;

                                filters.organizationUnitIds.push(auth.getOrganizationId());
                                if ($scope.find.class) {
                                    $scope.find.class.Page = $scope.find.page;
                                    $scope.find.class.ItemPerPage = $scope.find.itemsPerPage;
                                    $scope.find.class.showDetail = false;
                                    $scope.find.class.organizationUnitIds = filters.organizationUnitIds;
                                    $scope.find.class.DocumentTypeId = $scope.find.class.typeId;

                                    if ($scope.find.classType === 'Documental') {
                                        filters.DocumentTypes.push($scope.find.class);
                                    }
                                    else if ($scope.find.classType === 'Carpeta') {
                                        filters.ContainerTypes.push($scope.find.class);
                                    }
                                }
                                else {
                                    $scope.find.parameters = undefined;
                                    $scope.goToHome();
                                    return;
                                }

                                var parameters = {
                                    header: $scope.getHeaderFilter(),
                                    documentFullText: $scope.find.documentFullText,
                                    documentTypes: filters
                                };

                                $scope.find.filters = filters;
                                $scope.find.parameters = parameters;

                                $scope.goToHome();
                            };

                            $scope.getHeaderFilter = function () {
                                return {
                                    documentName: $scope.find.name,
                                    documentId: $scope.find.documentIdFilter,
                                    documentNameType: "Contains",
                                    createdDateFrom: $scope.find.documentCreationDateFilterFrom,
                                    createdDateTo: $scope.find.documentCreationDateFilterTo,
                                    createdBy: ($scope.find.selectedUser) ? $scope.find.selectedUser.id : null
                                };
                            };

                            $scope.clean = function () {
                                $scope.dateTimePickerFromOptions.clearInput();
                                $scope.dateTimePickerToOptions.clearInput();
                                $scope.find = {
                                    name: "",
                                    documentId: 0,
                                    createdDateFrom: "",
                                    createdDateTo: "",
                                    createdBy: "",
                                    class: undefined,
                                    documentIdFilter: "",
                                    documentCreationDateFilterFrom: "",
                                    documentCreationDateFilterTo: "",
                                    selectedUser: {},
                                    itemsPerPage: 15,
                                    page: 1,
                                    documentFullText: ""
                                };
                            };

                            $scope.init();
                        }]
                };
            }
        ]);
})();